<template>
    <CContainer fluid class="px-0">
        <CRow :form="true">
            <CCol sm="2">
                <CSelect
                    :value.sync="valueComponent.method"
                    :options="['get', 'post', 'put']"
                    :placeholder="$t('Select a method')"
                    :invalidFeedback="$t('Method is required')"
                    size="sm"
                />
            </CCol>
            <CCol sm="10">
                <CInput
                    :value.sync="valueComponent.url"
                    :placeholder="$t('https:// o http://')"
                    :invalidFeedback="$t('Url is required')"
                    type="url"
                    size="sm"
                />
            </CCol>
        </CRow>
        <CRow>
            <CCol>
                <CTabs variant="tabs" :active-tab="0">
                    <CTab :title="$t('Parameters')">
                        <CCard>
                            <CCardBody>
                                <CCTableAddItems
                                    :items.sync="valueComponent.queryParameters"
                                    :fields="[
                                        { key: 'key', label: 'key' },
                                        {
                                            key: 'value',
                                            label: 'value',
                                        },
                                    ]"
                                    noItemsViewText="Add parameter"
                                >
                                    <template #key="{ item }">
                                        <CInput
                                            :value.sync="item.key"
                                            :placeholder="$t('Enter the key')"
                                            :invalidFeedback="
                                                $t('Key is required')
                                            "
                                            class="mb-0"
                                            size="sm"
                                        />
                                    </template>
                                    <template #value="{ item }">
                                        <CInput
                                            :value.sync="item.value"
                                            :placeholder="$t('Enter the value')"
                                            :invalidFeedback="
                                                $t('Value is required')
                                            "
                                            class="mb-0"
                                            size="sm"
                                        />
                                    </template>
                                </CCTableAddItems>
                            </CCardBody>
                        </CCard>
                    </CTab>
                    <CTab :title="$t('Headers')">
                        <CCard>
                            <CCardBody>
                                <CCTableAddItems
                                    :items.sync="valueComponent.headers"
                                    :fields="[
                                        { key: 'key', label: 'key' },
                                        {
                                            key: 'value',
                                            label: 'value',
                                        },
                                    ]"
                                    noItemsViewText="Add header"
                                >
                                    <template #key="{ item }">
                                        <CInput
                                            :value.sync="item.key"
                                            :placeholder="$t('Enter the key')"
                                            :invalidFeedback="
                                                $t('Key is required')
                                            "
                                            class="mb-0"
                                            size="sm"
                                        />
                                    </template>
                                    <template #value="{ item }">
                                        <CInput
                                            :value.sync="item.value"
                                            :placeholder="$t('Enter the value')"
                                            :invalidFeedback="
                                                $t('Value is required')
                                            "
                                            class="mb-0"
                                            size="sm"
                                        />
                                    </template>
                                </CCTableAddItems>
                            </CCardBody>
                        </CCard>
                    </CTab>
                    <CTab :title="$t('Body')">
                        <CCard>
                            <CCardBody>
                                <CSelect
                                    :value.sync="valueComponent.bodyFormat"
                                    :options="['none', 'raw', 'form-data']"
                                    :label="$t('Body format')"
                                    :placeholder="$t('Select a body format')"
                                    size="sm"
                                />
                                <CTextarea
                                    v-if="valueComponent.bodyFormat === 'raw'"
                                    :value.sync="valueComponent.raw"
                                >
                                </CTextarea>
                                <CCTableAddItems
                                    v-if="
                                        valueComponent.bodyFormat ===
                                        'form-data'
                                    "
                                    :items.sync="valueComponent.formData"
                                    :fields="[
                                        { key: 'key', label: 'key' },
                                        {
                                            key: 'value',
                                            label: 'value',
                                        },
                                    ]"
                                    noItemsViewText="Add item"
                                >
                                    <template #key="{ item }">
                                        <CInput
                                            :value.sync="item.key"
                                            :placeholder="$t('Enter the key')"
                                            :invalidFeedback="
                                                $t('Key is required')
                                            "
                                            class="mb-0"
                                            size="sm"
                                        />
                                    </template>
                                    <template #value="{ item }">
                                        <CInput
                                            :value.sync="item.value"
                                            :placeholder="$t('Enter the value')"
                                            :invalidFeedback="
                                                $t('Value is required')
                                            "
                                            class="mb-0"
                                            size="sm"
                                        />
                                    </template>
                                </CCTableAddItems>
                            </CCardBody>
                        </CCard>
                    </CTab>
                    <CTab :title="$t('Settings')">
                        <CCard>
                            <CCardBody>
                                <CInput
                                    :value.sync="valueComponent.timeout"
                                    :label="$t('Timeout')"
                                    :placeholder="$t('Enter the timeout')"
                                    type="number"
                                    size="sm"
                                />
                            </CCardBody>
                        </CCard>
                    </CTab>
                </CTabs>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
import CCTable from "~/components/CCTable";
import CCTableAddItems from "~/components/CCTableAddItems";
import ButtonAdd from "~/components/ButtonAdd";
import SelectTags from "£lement/SelectTags";

import tableMixin from "~/mixins/table.js";
import baseMixin from "~/mixins/base.js";

import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import SelectFields from "£lement/SelectFields";

export default {
    name: "CCMethodApiConfiguration",
    mixins: [baseMixin, tableMixin],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    consts: {},
    options: {},
    components: {
        CCTable,
        ButtonAdd,
        SelectTags,
        SelectFields,
        CCTableAddItems,
    },
    data() {
        return {
            valueComponent: {
                url: null,
                method: "get",
                bodyFormat: "none",
                raw: null,
                formData: [],
                headers: [],
                queryParameters: [],
                timeout: null,
            },
            // url: null,
            // method: "get",
            // bodyFormat: "none",
            // headers: [],
            // queryParameters: [],
        };
    },
    props: {
        value: {
            required: true,
        },
        encode: {
            default: false,
        },
    },
    watch: {
        value(newValue) {
            if (this.encode) {
                if (newValue) {
                    const valueParsed = JSON.parse(newValue);
                    this.handleComponentValue(valueParsed);
                }
            } else {
                this.valueComponent = newValue;
            }
        },

        valueComponent: {
            handler(newValue) {
                this.emitChangeValue();
            },
            deep: true,
        },
    },
    methods: {
        getValue() {
            if (this.encode) {
                return JSON.stringify(this.valueComponent);
            }
            return this.valueComponent;
        },
        emitChangeValue() {
            this.$emit("update:value", this.getValue());
            this.$emit("change", this.getValue());
        },
        handleComponentValue(value) {
            let newValueComponent = {};
            for (const key in this.valueComponent) {
                if (Object.hasOwnProperty.call(value, key)) {
                    if (Array.isArray(value[key])) {
                        newValueComponent = {
                            ...newValueComponent,
                            [key]: [...value[key]],
                        };
                    } else {
                        newValueComponent = {
                            ...newValueComponent,
                            [key]: value[key],
                        };
                    }
                }
            }

            this.valueComponent = newValueComponent;
        },
    },
    async mounted() {
        if (this.encode) {
            if (this.value) {
                const valueParsed = JSON.parse(this.value);
                this.handleComponentValue(valueParsed);
            } else {
                // Emitimos el modelo por defecto de value en caso de que el valor sea vacio para mantener el formato
                // Solo lo haremos al momento de hacer el mounted del componente
                this.emitChangeValue();
            }
        } else {
            this.valueComponent = this.value;
        }
    },
};
</script>

<style>
.range__not_defined {
    accent-color: gray;
}
</style>
